import { render, staticRenderFns } from "./LogsAdmin.vue?vue&type=template&id=3d2e227f&scoped=true"
import script from "./LogsAdmin.vue?vue&type=script&lang=js"
export * from "./LogsAdmin.vue?vue&type=script&lang=js"
import style0 from "./LogsAdmin.vue?vue&type=style&index=0&id=3d2e227f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2e227f",
  null
  
)

export default component.exports